import { Component } from '@opten/compiler/metadata/component';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import { getCss } from '@opten/dom/get-css';
import { parseCssUnit } from '@opten/number/parse-css-unit';
import { scrollToElement } from '@opten/scroll/scroll-to-element';
import { linearTween } from '@opten/animation/linear-tween';
import { easeInOutQuad } from '@opten/animation/ease-in-out-quad';
import { getStickyOffset } from '../../utilities/scroll-helper';
import { Collapse } from '@opten/collapse/initializer';
import { mapFields } from '../../utilities/form';
import { Chart } from 'chart.js';

import { createChart } from '../../utilities/chart';
import Dataset from '../../utilities/chart';

const inDuration = 450;
const outDuration = 300;
export const RetirementCalculatorFormKey = 'RetirementCalculatorCalculatorForm';


@Component({ className: 'js-retirement-calculator' })
export default class RetirementCalculator implements OnInit {
	private _proposalElement: HTMLElement;
	private _formElement: HTMLFormElement;
	private _formSendCalculationsElementWrapper: HTMLElement;
	private _formSendCalculationsElement: HTMLFormElement;
	private _loadingIndicator = '<div class="c-loading-indicator">Loading...</div>';

	private _hasProposal: boolean = false;

	constructor(private element: HTMLElement) {
		this._proposalElement = element.getElementsByClassName(
			'js-retirement-calculator-proposal'
		)[0] as HTMLElement;
		this._formElement = this.element.getElementsByClassName(
			'js-retirement-calculator-form'
		)[0] as HTMLFormElement;
	}

	onInit() {
		this._formElement.addEventListener('submit', event => {
			event.preventDefault();
			this._fetch();
		});
	}

	private _createChart() {
		let canvas: HTMLCanvasElement = (document.getElementById('js-retirementCalculationChart') as HTMLCanvasElement);
		let xAxisData: string[] = this._getValuesByElementName('js-year');
		let yAxisData: Dataset[] = this._getDataset();

		if (canvas !== null && canvas !== undefined) {
			try {
				let chart: Chart = createChart(canvas, xAxisData, yAxisData);
				//initially handle resize
				//handleResize(chart,chart.size)
			} catch (error) {
				console.log(error);
			}
		}
	}

	private _getValuesByElementName(name: string) {
		let values = [];
		let elements = document.getElementsByName(name);
		Array.from(elements).forEach(element => {
			values.push(Number((element as HTMLInputElement).value));
		});
		return values;
	}

	private _getDataset() {
		let dataset: Dataset[];

		let yearlyInvestments: number[] = this._getValuesByElementName('js-yearlyInvestment');
		let yearlyProfits: number[] = this._getValuesByElementName('js-yearlyProfit');
		let yearlyBasicProfits: number[] = this._getValuesByElementName('js-yearlyBasicProfit');

		dataset = [
			{
				label: this._getLabelByElementName('js-yearlyInvestment-label'),
				backgroundColor: 'rgb(221, 221, 221)',
				borderColor: 'rgb(221, 221, 221)',
				data: yearlyInvestments
			},
			{
				label: this._getLabelByElementName('js-yearlyBasicProfit-label'),
				backgroundColor: 'rgb(196, 229, 250)',
				borderColor: 'rgb(196, 229, 250)',
				data: yearlyBasicProfits
			},
			{
				label: this._getLabelByElementName('js-yearlyProfit-label'),
				backgroundColor: 'rgb(0, 110, 181)',
				borderColor: 'rgb(0, 110, 181)',
				data: yearlyProfits
			}
		]

		return dataset;
	}
	
	private _getLabelByElementName(name: string) {
		let elements = document.getElementsByClassName(name);
		let label = '';
		if (elements && elements.length > 0) {
			label = elements[0].getAttribute('data-label');
		}
		return label;
	}

	private _apply(link: HTMLAnchorElement) {
		if (link.hasAttribute('data-proposal-id')) {
			const form = document.createElement('form');
			form.method = 'POST';
			form.action = link.href;
			form.style.display = 'none';

			// todo: better way for ufprt?
			mapFields(this._formElement, ['ufprt']).forEach((value, key) =>
				form.appendChild(this._createHiddenInput(key, value))
			);

			form.appendChild(
				this._createHiddenInput(
					'ProposalId',
					link.getAttribute('data-proposal-id')
				)
			);

			form.appendChild(
				this._createHiddenInput(
					'SpanIds',
					link.getAttribute('data-span-ids')
				)
			);

			document.body.appendChild(form);
			form.submit();
		}
	}

	private _createHiddenInput(name: string, value: any): HTMLInputElement {
		const input = document.createElement('input');
		input.type = 'hidden';
		input.name = name;
		input.value = value;
		return input;
	}

	private _fetch() {
		this._proposalElement.style.overflow = 'hidden';

		const get = () => {
			const formData = new FormData();
			mapFields(this._formElement).forEach((value, key) =>
				formData.append(key, value)
			);
			this._proposalElement.innerHTML = this._loadingIndicator;

			fetch(this._formElement.action, {
				method: this._formElement.method,
				headers: {
					// todo: set language from chooser in the future
					'accept-language': 'de-CH',
					// todo: why? if we change to a api controller we don't have this problem...
					'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
				},
				body: formData
			})
				.then(response => {
					if (response.ok) {
						const contentType = response.headers.get(
							'content-type'
						);

						if (contentType && contentType.includes('text/html')) {
							return response.text();
						}
					}

					return null;
				})
				.then(html => {
					if (html) {
						// todo: kill events?
						this._proposalElement.innerHTML = html;

						// initialize collapse
						Array.from(
							this._proposalElement.getElementsByClassName(
								'js-retirement-calculator-proposal-collapse'
							)
						).forEach(element =>
							new Collapse(element as HTMLElement).hide()
						);


						// initialize spans
						Array.from(
							this._proposalElement.getElementsByClassName(
								'js-select-retirement-calculator-proposal-span'
							)
						).forEach(select =>
							select.addEventListener('change', () =>
								this._onChangeEvent(select as HTMLSelectElement)
							)
						);
						this.initializeContentForm();

					} else {
						// todo: apply in html and get with javascript for translation?
						this._proposalElement.innerHTML = `<div class="alert alert-danger">
                            Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.
                        </div>`;
					}

					this._show();
				});
		};

		if ($(this._formElement).valid()) {
			if (this._hasProposal) {
				this._hide(() => get());
			} else {
				get();
			}
		}
	}

	private initializeContentForm() {
		const formElementWrappers = this._proposalElement.getElementsByClassName('js-retirement-calculator-savings-form');
		if (formElementWrappers && formElementWrappers.length > 0) {
			this._formSendCalculationsElementWrapper = formElementWrappers[0] as HTMLElement;
		}
		if (this._formSendCalculationsElementWrapper) {
			const formElements = this._formSendCalculationsElementWrapper.getElementsByTagName('form');
			if (formElements && formElements.length > 0) {
				this._formSendCalculationsElement = formElements[0];
				this._formSendCalculationsElement.addEventListener('submit', (e) => this.handleSubmitSendCalculationsForm(e));

				// extend jquery range validator to work for required checkboxes
				var defaultRangeValidator = $.validator.methods.range;
				$.validator.methods.range = function (value, element, param) {
					if (element.type === 'checkbox') {
						// if it's a checkbox return true if it is checked
						return element.checked;
					} else {
						// otherwise run the default validation function
						return defaultRangeValidator.call(this, value, element, param);
					}
				}
				$.validator.unobtrusive.parse('form');
			}

		}
	}

	private handleSubmitSendCalculationsForm(event: Event) {
		event.preventDefault();
		if ($(this._formSendCalculationsElement).valid()) {
			const formData = $(this._formSendCalculationsElement).serialize();
			this._formSendCalculationsElementWrapper.innerHTML = this._loadingIndicator;
			fetch(this._formSendCalculationsElement.action, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'accept-language': 'de-CH',
					// todo: why? if we change to a api controller we don't have this problem...
					'X-Requested-With': 'XMLHttpRequest' // otherwise accept-language is ignored
				},
				body: formData,
				credentials: 'include'
			})
				.then(response => {
					const contentType = response.headers.get('content-type');
					if (contentType && contentType.includes('text/html')) {
						return response.text();
					}
				})
				.then(data => {
					this._formSendCalculationsElementWrapper.innerHTML = data;
					this.initializeContentForm();
				});
		}
	}

	private _hide(callback: Function) {
		if (!this._hasProposal) {
			callback();
		} else {
			this._animate(
				this._proposalElement.offsetHeight,
				this._proposalElement.offsetHeight * -1,
				outDuration,
				() => {
					this._proposalElement.style.display = 'none';
					this._hasProposal = false;
					callback();
				}
			);
		}
	}

	private _show() {
		this._proposalElement.style.display = 'block';
		this._animate(0, this._proposalElement.offsetHeight, inDuration);

		let offset = getStickyOffset();
		offset += parseCssUnit(getCss(this._proposalElement, 'margin-top'));

		scrollToElement(
			this._proposalElement,
			linearTween,
			inDuration,
			offset * -1
		);

		this._hasProposal = true;

		Array.from(
			this.element.getElementsByClassName(
				'js-retirement-calculator-proposal-apply'
			)
		).forEach((link: HTMLAnchorElement) =>
			link.addEventListener('click', event => {
				event.preventDefault();

				this._apply(link);
			})
		);
		this._createChart();
	}

	private _animate(
		start: number,
		distance: number,
		duration: number,
		complete?: Function
	) {
		// todo: function in @opten/events?
		let timeStart: number;
		let timeElapsed: number;

		const loop = time => {
			timeElapsed = time - timeStart;

			this._proposalElement.style.height = `${easeInOutQuad(
				timeElapsed,
				start,
				distance,
				duration
			)}px`;

			if (timeElapsed < duration) {
				requestAnimationFrame.call(window, loop);
			} else {
				this._proposalElement.style.height = null;
				if (complete) {
					complete();
				}
			}
		};

		requestAnimationFrame.call(window, time => {
			timeStart = time;
			loop(time);
		});
	}

	private _onChangeEvent(element: HTMLSelectElement) {
		const mortgageId = element.getAttribute('data-mortgage-id');
		const proposalId = element.getAttribute('data-proposal-id');

		const all = Array.from(
			document.querySelectorAll<HTMLElement>(
				`[data-proposal-id="${proposalId}"].js-retirement-calculator-proposal-details,
                [data-mortgage-id="${mortgageId}"][data-proposal-id="${proposalId}"].js-retirement-calculator-proposal-table`
			)
		);

		const others = all.filter(
			o => o.getAttribute('data-span-id') !== element.value
		);

		// todo: collapse or use _animate method?
		others.forEach(element => (element.style.display = 'none'));

		// todo: collapse or use _animate method?
		all.filter(element => others.indexOf(element) < 0).forEach(
			element => (element.style.display = 'block')
		);

		const button = document.querySelector<HTMLElement>(
			`[data-proposal-id="${proposalId}"].js-retirement-calculator-proposal-apply`
		);

		if (button) {
			const spanIds = button.getAttribute('data-span-ids').split(',');

			spanIds.splice(
				spanIds.indexOf(element.getAttribute('data-old-id')),
				1,
				element.value
			);

			element.setAttribute('data-old-id', element.value);
			button.setAttribute('data-span-ids', spanIds.join(','));
		}
	}
}